import { type UseQueryResult, useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type components } from 'src/api/playerPayback/api'

export const useGetRewardsCatalogByRewardId = ({
  rewardId,
}: {
  rewardId: number
}): UseQueryResult<
  Array<components['schemas']['FullRewardsCatalogRewardDTO']>
> => {
  const get = useTypedApiClient({
    path: '/admin/rewards-catalog-rewards/reward/{id}',
    method: 'get',
  })
  return useQuery({
    queryKey: ['/admin/rewards-catalog-rewards/reward', rewardId],
    queryFn: async () => {
      const { data } = await get({ id: rewardId })
      return data
    },
  })
}
